var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuiz = function SvgQuiz(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 13.211V1.86801C16.4945 1.24777 15.9893 0.748333 15.369 0.750007H1.875C1.25783 0.747785 0.754951 1.24485 0.75 1.86201V13.131C0.755494 13.7514 1.26058 14.2511 1.881 14.25H15.45C15.7271 14.2516 15.9934 14.143 16.1903 13.9481C16.3873 13.7532 16.4987 13.4881 16.5 13.211Z",
    fill: "#DAD8FF",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12V8.10002C6.79305 7.31379 7.4636 6.7103 8.25 6.75002C9.0364 6.7103 9.70695 7.31379 9.75 8.10002V12",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.75H9.75",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 18.75H16.5C16.9142 18.75 17.25 19.0858 17.25 19.5V20.25C17.25 20.6642 16.9142 21 16.5 21H14.25V18.75Z",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 16.5H16.5C16.9142 16.5 17.25 16.8358 17.25 17.25V18C17.25 18.4142 16.9142 18.75 16.5 18.75H14.25V16.5Z",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.25V22.131C7.50549 22.7514 8.01058 23.2511 8.631 23.25H22.2C22.4771 23.2516 22.7434 23.143 22.9403 22.9481C23.1373 22.7532 23.2487 22.4881 23.25 22.211V10.868C23.2445 10.2478 22.7393 9.74833 22.119 9.75H19.5",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.5H23.25",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.5H16.5",
    stroke: "#4239FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuiz);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";